import { render } from "./Task_board.vue?vue&type=template&id=433249ba&scoped=true"
import script from "./Task_board.vue?vue&type=script&lang=js"
export * from "./Task_board.vue?vue&type=script&lang=js"

import "./Task_board.vue?vue&type=style&index=0&id=433249ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433249ba"]])

export default __exports__